document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('.hero-slider');
  if (!slider) return;

  const track = slider.querySelector('.hero-slider__track');
  const dots = slider.querySelectorAll('.hero-slider__dot');
  const slides = slider.querySelectorAll('.hero-slide');

  let index = 0;
  let timer = null;

  const setActiveDot = () => {
    dots.forEach(d => d.classList.remove('is-active'));
    if (dots[index]) dots[index].classList.add('is-active');
  };

  const applyTransform = () => {
    const w = slider.clientWidth;
    track.style.transform = `translateX(-${index * w}px)`;
  };

  const goTo = (i) => {
    index = Math.max(0, Math.min(i, slides.length - 1));
    applyTransform();
    setActiveDot();
  };

  // Click en dots
  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      const i = parseInt(dot.dataset.slide, 10);
      if (!Number.isNaN(i)) goTo(i);
    });
  });

  // Autoplay
  const autoplay = slider.dataset.autoplay === 'true';
  const time = parseInt(slider.dataset.interval, 10) || 5000;

  const startAutoplay = () => {
    if (!autoplay || slides.length <= 1) return;
    stopAutoplay();
    timer = setInterval(() => {
      goTo((index + 1) % slides.length);
    }, time);
  };

  const stopAutoplay = () => {
    if (timer) clearInterval(timer);
    timer = null;
  };

  // Recalcular en resize (mantener el slide actual)
  let resizeRaf = null;
  window.addEventListener('resize', () => {
    if (resizeRaf) cancelAnimationFrame(resizeRaf);
    resizeRaf = requestAnimationFrame(() => {
      applyTransform();
    });
  });

  // Init
  goTo(0);
  startAutoplay();
});
